import { toPercent } from '@utils/helpers';

export default {
  methods: {
    toPercent,
  },
};
